import { variables } from "../variables";
import Axios from "axios";

export default {
    state: {
        users:[],
        
    },
    getters: {
       
    },
    mutations: {    
       
    },
    actions: {
        async getListOfUsers(context, params){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/users?clubCode='+params.clubCode+'&pageNumber='+params.pageNumber+'&pageSize='+params.pageSize);
            return response
        },
        async getListOfUsersUnssigned(context){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/clubs/unassigned-administrators');
            return response
        },
        async postUser(context, body){
            let response = await context.rootGetters.api.post(variables.serverUrl+'/api/v1/users', body);
            return response;
        },
        async getListOfAdministrators(context, params){
            let response = await context.rootGetters.api.get(variables.serverUrl+'/api/v1/clubs/administrators?pageNumber='+params.pageNumber+'&pageSize='+params.pageSize+'&search='+params.search);
            return response
        },
        async createUserPassword(context, body){
            let response = await Axios.post(variables.serverUrl+'/api/v1/users/assign-password', {
                code: body.code,
                password: body.password
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'es-MX'
                }
            });
            return response;
        },
        async deleteUser(context, uuid){
            let response = await context.rootGetters.api.delete(variables.serverUrl+'/api/v1/users/'+uuid);
            return response;

        },
        async updateUser(context, uuid, body){
            let response = await context.rootGetters.api.put(variables.serverUrl+'/api/v1/users/'+uuid, body);
            return response;
        },
        async sendEmailPasswordRecovery(context, {email}){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/users/password-recovery/${email}`);
        },
        async resetPassword(context, body){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/users/reset-password`, body);
        },
    }
}